import { loadFireBase } from '../../lib/firebase';

export const LOAD_PLANTS_SUCCESS = 'LOAD_PLANTS_SUCCESS';
export const LOAD_PLANTS_FAILURE = 'LOAD_PLANTS_FAILURE';
export const LOAD_PLANTS_UPDATE_AFTER_DELETE = 'LOAD_PLANTS_UPDATE_AFTER_DELETE';
export const UPDATE_PLANTS = 'UPDATE_PLANTS';
export const UPDATE_PLANT_ITEM = 'UPDATE_PLANT_ITEM';

const firebase = loadFireBase();
const base = firebase.base;

export const fetchPlants = (userId) => {
  return base.fetch('plants', {
    asArray: true,
    queries: {
      orderByChild: 'userId',
      equalTo: userId
    }
  }).then(data => {
    return data;
  });
};

export const getPlantsSuccess = (resp) => ({
  type: LOAD_PLANTS_SUCCESS,
  payload: resp,
});

export const getPlantsError = (error) => ({
  type: LOAD_PLANTS_FAILURE,
  error: error,
});

export const getPlants = (userId) => {
  return function(dispatch) {
    return fetchPlants(userId).then(
      resp => dispatch(getPlantsSuccess(resp)),
      error => dispatch(getPlantsError(error))
    )
  }
};

export const updatePlants = (plant) => ({
  type: UPDATE_PLANTS,
  plantToAdd: plant
});

export const updatePlantsAfterDelete = (plantKeyId) => ({
  type: LOAD_PLANTS_UPDATE_AFTER_DELETE,
  plantKeyId
});

export const updatePlantItem = (plant) => ({
  type: UPDATE_PLANT_ITEM,
  plant,
});
